import {
  registerMicroApps,
  addGlobalUncaughtErrorHandler,
  start,
} from "qiankun";
import apps from "./apps";
/** 注册微应用 */
registerMicroApps(apps, {
  // 微应用加载前
  beforeLoad: () => {
    return Promise.resolve();
  },
  beforeMount: () => {
    return Promise.resolve();
  },
  afterMount: () => {
    return Promise.resolve();
  },
});

addGlobalUncaughtErrorHandler((event) => {
  const { message: msg } = event;
  if (msg && msg.includes("died in status LOADING_SOURCE_CODE")) {
    console.error("微应用加载失败，请检查应用是否可运行");
  }
});

export default start;
